<template>
    <div>
        <Modal id="dados_passaporte" :open="show" :size="'modal-xl'" customSizeWid="" :FooterDefault="false" :ClassBG="true" customModalBody="" :customModalMain="'z-index:1052'">
            <template v-slot:header>
                <h6 class="modal-title">Dados do Passaporte AAA</h6>
                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                </button>
            </template>
            <template v-slot:body>
                <div class="row" v-if="InscricaoCrud">
                    <div class="coluna-dados col-3">
                        <label class="form-label" style="font-size: 20px">Dados da Localizador</label>
                        <div class="linha-cinza" style="margin-top: -5px;"></div>
                        <p><strong>Localizador:</strong> {{InscricaoCrud.inscricao.cdLocalizador}} </p>
                        <p><strong>Qtd Participantes:</strong> {{InscricaoCrud.inscricao.qtdParticipantes}}</p>
                        <p>
                            <strong>Passaportes gerados:</strong>
                            <template v-if="lstParticipante.length > 0">
                                <ul>
                                    <li v-for="(item,index) in lstParticipante" :key="index">{{item.cdPassaporte}} - {{item.nmParticipante}}</li>
                                </ul>
                            </template>
                            <template v-else>
                                <span>Nenhum passaporte gerado</span>
                            </template>
                        </p>
                        <p><strong>Nome:</strong> {{InscricaoCrud.instituicao.nmNome}}</p>
                        <template v-if="InscricaoCrud.instituicao.tpInstituicao == 'F'">
                            <p><strong>CPF:</strong> {{InscricaoCrud.instituicao.nrCpfCnpj}}</p>
                            <p><strong>E-mail:</strong> {{InscricaoCrud.instituicao.dsEmail}}</p>
                        </template>
                        <template v-else>
                            <p><strong>CNPJ:</strong> {{InscricaoCrud.instituicao.nrCpfCnpj}}</p>
                        </template>

                        <p><strong>Telefone:</strong> {{InscricaoCrud.instituicao.nrTelefone}}</p>
                        <p><strong>Celular:</strong> {{InscricaoCrud.instituicao.nrCelular}}</p>

                        <p>
                            <strong>Endereço:</strong>
                            <template v-if="InscricaoCrud.instituicao.dsEndereco != null && InscricaoCrud.instituicao.dsEndereco != ''">
                                {{InscricaoCrud.instituicao.dsEndereco}}
                            </template>
                            <template v-if="InscricaoCrud.instituicao.nrNumero != null && InscricaoCrud.instituicao.nrNumero != ''">
                                , Nº{{InscricaoCrud.instituicao.nrNumero}}
                            </template>
                            <template v-if="InscricaoCrud.instituicao.dsComplemento != null && InscricaoCrud.instituicao.dsComplemento != ''">
                                , {{InscricaoCrud.instituicao.dsComplemento}}
                            </template>
                            <template v-if="InscricaoCrud.instituicao.nmBairro != null && InscricaoCrud.instituicao.nmBairro != ''">
                                , {{InscricaoCrud.instituicao.nmBairro}}
                            </template>
                            <template v-if="InscricaoCrud.instituicao.nmCidade != null && InscricaoCrud.instituicao.nmCidade != ''">
                                , {{InscricaoCrud.instituicao.nmCidade}}
                            </template>
                            <template v-if="InscricaoCrud.instituicao.nmUf != null && InscricaoCrud.instituicao.nmUf != ''">
                                - {{InscricaoCrud.instituicao.nmUf}}
                            </template>
                        </p>

                        <template v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                            <label class="form-label mt-2" style="font-size: 20px">Responsável</label>
                            <div class="linha-cinza" style="margin-top: -5px;"></div>
                            <p><strong>Nome:</strong> {{InscricaoCrud.inscricao.nmNomeResponsavel}}</p>
                            <p><strong>E-mail:</strong>{{InscricaoCrud.inscricao.dsEmailResponsavel}}</p>
                            <p><strong>Telefone:</strong> {{InscricaoCrud.inscricao.nrTelefoneResponsavel}}</p>
                            <p><strong>Departamento:</strong> {{getNmDepartamento(InscricaoCrud.inscricao.idDepartamentoResponsavel)}}</p>
                            <p><strong>Função:</strong> {{getNmFuncao(InscricaoCrud.inscricao.idFuncaoResponsavel)}}</p>

                            <label class="form-label mt-2" style="font-size: 20px">Financeiro</label>
                            <div class="linha-cinza" style="margin-top: -5px;"></div>
                            <p><strong>Nome:</strong> {{InscricaoCrud.inscricao.nmNomeFinanceiro}}</p>
                            <p><strong>E-mail:</strong> {{InscricaoCrud.inscricao.dsEmailFinanceiro}}</p>
                            <p><strong>Telefone:</strong> {{InscricaoCrud.inscricao.nrTelefoneFinanceiro}}</p>
                            <p><strong>Departamento:</strong> {{getNmDepartamento(InscricaoCrud.inscricao.idDepartamentoFinanceiro)}}</p>
                            <p><strong>Função:</strong> {{getNmFuncao(InscricaoCrud.inscricao.idFuncaoFinanceiro)}}</p>
                        </template>

                    </div>
                    <div class="col-9">
                        <Form ref="Form_DadosPassaporte" @submit="submit_Form_DadosPassaporte">

                            <div class="col-12">
                                <div class="">
                                    <label class="form-label" style="font-size: 20px">Dados do Passaporte</label>
                                </div>
                                <div class="linha-cinza" style="margin-top: -5px"></div>
                            </div>

                            <div class="row mt-2" v-if="ParticipanteCrud.flCancelado == 'Sim'">
                                <div class="col-12">
                                    <div class="alert alert-danger">
                                        <strong>Atenção!</strong> Este participante está inativo
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-9">
                                    <label for="dsEmail" class="form-label">E-mail</label>
                                    <Field disabled name="dsEmail" label="E-mail" type="text" class="form-control shadow-v2" v-model="ParticipanteCrud.dsEmail" />
                                    <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col-3">
                                    <label class="form-label">Sexo</label>
                                    <vue-select :options="sexos" v-model="filter_tpSexo"
                                                :label-by="(e) => (e.text)" placeholder="Digite o sexo e selecione"
                                                searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                class="form-control shadow-v2"
                                                :class="{ filled: ParticipanteCrud.tpSexo != null }">
                                    </vue-select>
                                    <!--<Field name="tpSexo" label="Sexo" type="hidden" rules="min_value:1" v-model="ParticipanteCrud.tpSexo" />-->
                                    <ErrorMessage name="tpSexo" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-6">
                                    <label for="nmParticipante" class="form-label">Nome Completo</label>
                                    <Field name="nmParticipante" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                           rules="required" v-model="ParticipanteCrud.nmParticipante" />
                                    <ErrorMessage name="nmParticipante" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col-6">
                                    <label for="nmApelido" class="form-label">Nome Crachá</label>
                                    <Field name="nmApelido" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                           rules="required" v-model="ParticipanteCrud.nmApelido" />
                                    <ErrorMessage name="nmApelido" class="form-error" v-show="showErrorMessage" />
                                </div>

                            </div>
                            <div class="row mt-2">
                                <div class="col-3">
                                    <label class="form-label">CPF</label>
                                    <div class="input-group">
                                        <Field v-maska="'##.###.###/####-##'" name="nrCpf" label="nrCpf" type="text" class="form-control shadow-v2" :class="{ filled: ParticipanteCrud.nrCpf }" readonly v-model="ParticipanteCrud.nrCpf" />
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label class="form-label">RG</label>
                                    <div class="input-group">
                                        <Field v-maska="'##.###.###/####-##'" name="nrRg" label="nrRg" type="text" class="form-control shadow-v2" :class="{ filled: ParticipanteCrud.nrRg }" readonly v-model="ParticipanteCrud.nrRg" />
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label class="form-label">Celular</label>
                                    <Field name="nrCelular" label="Celular" type="text" class="form-control shadow-v2"
                                           :class="{ filled: ParticipanteCrud.nrCelular }" rules="required"
                                           v-maska="'(##) #####-####'" v-model="ParticipanteCrud.nrCelular" />
                                </div>
                                <div class="col-3">
                                    <label class="form-label">Data Nascimento</label>
                                    <Field name="dtNascimento" label="dtNascimento" type="text" class="form-control shadow-v2"
                                           :class="{ filled: ParticipanteCrud.dtNascimento }" rules="required"
                                           v-maska="'##/##/####'" v-model="ParticipanteCrud.dtNascimento" />
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="form-label">Departamento</label>
                                    <vue-select :options="departamentos" v-model="filter_departamento"
                                                :label-by="(e) => (e.nmDepartamento)"
                                                placeholder="Digite o nome do Departamento e selecione" searchable
                                                search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                                class="form-control shadow-v2"
                                                :class="{ filled: ParticipanteCrud.idDepartamento > 0 }">
                                    </vue-select>
                                    <Field name="idDepartamento" label="Departamento" type="hidden" rules="min_value:1"
                                           v-model="ParticipanteCrud.idDepartamento" />
                                    <ErrorMessage name="idDepartamento" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col-4">
                                    <label class="form-label">Função</label>
                                    <vue-select :options="funcoes" v-model="filter_funcao"
                                                :label-by="(e) => (e.nmFuncao)" placeholder="Digite o nome da Função e selecione"
                                                searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                :min="1" class="form-control shadow-v2"
                                                :class="{ filled: ParticipanteCrud.idFuncao > 0 }">
                                    </vue-select>
                                    <Field name="idFuncao" label="Função" type="hidden" rules="min_value:1" v-model="ParticipanteCrud.idFuncao" />
                                    <ErrorMessage name="idFuncao" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col-4">
                                    <label class="form-label">UF</label>
                                    <Field name="nmUf" label="Estado" type="text" class="form-control shadow-v2"
                                           :class="{ filled: ParticipanteCrud.nmUf }" v-model="ParticipanteCrud.nmUf" />
                                </div>
                            </div>

                            <!-- EXTRAS -->
                            <div class="col-12 mt-2">
                                <div class="d-flex justify-content-between my-2">
                                    <div class="d-flex">
                                        <label class="form-label me-2" style="font-size: 20px">Extras</label>
                                    </div>
                                </div>
                                <div class="linha-cinza" style="margin-top: -1px"></div>
                            </div>

                            <div class="row mt-2" v-if="filtro_idTipoDeficiencia">
                                <div class="col-12" v-if="filtro_idTipoDeficiencia.idTipoDeficiencia > 0">
                                    <div class="alert alert-danger" role="alert">
                                        <strong>Deficiência:</strong> {{filtro_idTipoDeficiencia.nmDeficiencia}}
                                        <template v-if="filtro_idTipoDeficiencia.idTipoDeficiencia == 4 && ParticipanteCrud">
                                            : {{ParticipanteCrud.dsTipoDeficiencia}}
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-6">
                                    <div class="checkbox">
                                        <label class="form-control-checkbox me-4">
                                            <input type="checkbox" v-model="filtro_restricaoalimentar" /> Restrição Alimentar
                                        </label>
                                    </div>
                                    <div class="mt-2 ms-2" v-if="filtro_restricaoalimentar">
                                        <template v-for="(item,index) in lstRestricaoAlimentar" :key="index">
                                            <label class="form-control-checkbox me-4 mb-2">
                                                <input :id="'lstRestricaoAlimentar['+index+'].idTipoAlimentacao'" :name="'lstRestricaoAlimentar['+index+'].idTipoAlimentacao'" type="checkbox" v-model="item.checked_box" /> {{item.nmAlimentacao}}
                                            </label>
                                            <input v-if="item.nmAlimentacao == 'Alérgico'" type="text" :class="'form-control '+(item.checked_box?'':'d-none')" :id="'lstRestricaoAlimentar['+index+'].dsTipoAlimentacao'" :name="'lstRestricaoAlimentar['+index+'].dsTipoAlimentacao'" :value="item.dsTipoAlimentacao" v-model="item.dsTipoAlimentacao" />

                                        </template>
                                    </div>

                                </div>
                                <div class="col-6">
                                    <div class="checkbox">
                                        <label class="form-control-checkbox me-4">
                                            <input type="checkbox" v-model="filtro_pessoaDeficiencia" /> Pessoa com Deficiência
                                        </label>
                                    </div>
                                    <div class="mt-2 ms-2" v-if="filtro_pessoaDeficiencia">
                                        <vue-select :options="lstPessoaDeficiencia" v-model="filtro_idTipoDeficiencia"
                                                    :label-by="(e) => (e.nmDeficiencia)" placeholder="Digite o nome da Deficiência e selecione"
                                                    searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                    :min="1" class="form-control shadow-v2"
                                                    :class="{ filled: filtro_pessoaDeficiencia && ParticipanteCrud.idTipoDeficiencia > 0 }">
                                        </vue-select>
                                        <Field name="idTipoDeficiencia" label="Deficiência" type="hidden" v-model="ParticipanteCrud.idTipoDeficiencia" />
                                        <Field v-if="fl_descricaoDeficiencia" :name="'dsTipoDeficiencia'" placeholder="Qual ?" label="dsTipoDeficiencia" type="text" class="form-control shadow-v2 mt-2" :class="{ filled: false }" v-model="ParticipanteCrud.dsTipoDeficiencia" />

                                    </div>
                                </div>
                            </div>

                            <!-- VINCULO -->
                            <div class="col-12 mt-2">
                                <div class="d-flex justify-content-between my-2">
                                    <div class="d-flex">
                                        <label class="form-label me-2" style="font-size: 20px">Vínculo Cadastro</label>
                                        <!-- STATUS VINCULO -->
                                        <div v-if="( (ParticipanteCrud.idPessoa > 0) && (ParticipanteCrud.idInstituicao > 0) )" class="spinner-grow-static text-success" role="status" />
                                        <div v-else class="spinner-grow-static text-danger" role="status" />
                                    </div>
                                    <!-- BTN NOVO VINCULO -->
                                    <button class="btn-style-white" type="button" @click="isOpenModalVincularCadastro = true"><i class="fas fa-user"></i> Novo</button>
                                </div>
                                <div class="linha-cinza" style="margin-top: -1px"></div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-12">
                                    <label class="form-label">Cadastro Vinculado</label>
                                    <vue-select :options="vinculos" v-model="cadastro_vinculado"
                                                :label-by="(e) => (e.text)" placeholder="Digite o nome do Usuário e selecione"
                                                searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                class="form-control shadow-v2"
                                                :class="{ filled: false }">
                                    </vue-select>
                                    <!--<Field name="idPessoa" label="Vinculo" type="hidden" rules="min_value:1" v-model="ParticipanteCrud.idPessoa" />-->
                                    <!--<ErrorMessage name="idPessoa" class="form-error" v-show="showErrorMessage" />-->
                                </div>
                            </div>

                            <div class="row mt-2" v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                                <div class="col-12">
                                    <label class="form-label">Instituição Vinculada</label>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" v-model="txtPesquisaInstituicao" v-on:keyup.enter="pesquisaInstituicao" placeholder="Buscar por Código, Nome ou CNPJ" aria-label="Buscar por Código, Nome ou CNPJ" aria-describedby="basic-addon2">
                                                <span class="input-group-text" id="basic-addon2" @click="pesquisaInstituicao"><i class="fas fa-search"></i></span>
                                            </div>
                                        </div>
                                    </div>


                                    <vue-select :options="instituicoes" v-model="cadastro_instituicao"
                                                :label-by="(e) => (e.text)" placeholder="Digite o nome da Instituição e selecione"
                                                searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                class="form-control shadow-v2"
                                                :class="{ filled: false }">
                                    </vue-select>
                                    <!--<Field name="idInstituicao" label="Instituição" type="hidden" rules="min_value:1" v-model="ParticipanteCrud.idInstituicao" />-->
                                    <!--<ErrorMessage name="idInstituicao" class="form-error" v-show="showErrorMessage" />-->
                                </div>
                            </div>

                        </Form>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                        Fechar
                    </button>
                    <button type="button" class="btn btn-red-v2" @click="submit_Form_DadosPassaporte">
                        <i class="fas fa-save pe-2"></i>
                        Salvar
                    </button>
                </div>
            </template>
        </Modal>

        <modal-warper target="vincular_cadastro_passaporte" :show="isOpenModalVincularCadastro" @close="isOpenModalVincularCadastro = false">
            <VincularCadastro :dadosCadastro="{tpCadastro: 'F',nrCpfCnpj: ParticipanteCrud.nrCpf ,nmPessoa: ParticipanteCrud.nmParticipante
                              ,dtNascimento: ParticipanteCrud.dtNascimento,dsEmail: ParticipanteCrud.dsEmail,nrTelefone: '',nrCelular: ParticipanteCrud.nrCelular
                              ,nmCidade: '',nmUf: '',dsEndereco: '',nrNumero: '',nmBairro: '',dsComplemento: '',dsCep: '',
                              idVinculo: ParticipanteCrud.idInscricao,idDepartamento: ParticipanteCrud.idDepartamento,idFuncao: ParticipanteCrud.idFuncao,}"
                              :show="isOpenModalVincularCadastro" :callback="respostaVinculo" ref="vincular_cadastro_passaporte" :id="'vincular_cadastro_passaporte'" />
        </modal-warper>
    </div>
</template>

<script>
    import VincularCadastro from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/VincularCadastro.vue'
    import ModalWarper from "@/components/App/ModalWarper.vue";

    import Modal from "@/components/App/Modal.vue";
    import axios from "axios";

    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";
    import moment from 'moment';

    export default {
        name: "DadosPassaporte",
        components: {
            Modal,
            "vue-select": VueNextSelect,
            ModalWarper,
            VincularCadastro
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idInscricao: {
                type: Number,
                default: 0
            },
            idParticipante: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                sexos: [
                    { text: "Masculino", value: "M" },
                    { text: "Feminino", value: "F" },
                    { text: "Outro", value: "O" },
                ],
                departamentos: [],
                funcoes: [],
                vinculos: [],
                instituicoes: [],

                InscricaoCrud: {
                    inscricao: {
                        dsEmail: '',
                        nmNomeResponsavel: '',
                        dsEmailResponsavel: '',
                        nrTelefoneResponsavel: '',
                        nrCelularResponsavel: '',
                        idDepartamentoResponsavel: '',
                        idFuncaoResponsavel: '',
                        nmNomeFinanceiro: '',
                        dsEmailFinanceiro: '',
                        nrTelefoneFinanceiro: '',
                        nrCelularFinanceiro: '',
                        idDepartamentoFinanceiro: '',
                        idFuncaoFinanceiro: '',
                        idConvenio: '',
                        flSalaoPrincipal: false,
                        tpSexo: null,
                    },
                    instituicao:
                    {
                        nmNome: '',
                        nrTelefone: '',
                        nrCelular: '',
                        dsCep: '',
                        dsEndereco: '',
                        nrNumero: '',
                        dsComplemento: '',
                        nmBairro: '',
                        nmCidade: '',
                        nmUf: '',
                        idAmbito: '',
                        nrCpfCnpj: '',
                    },
                },
                lstParticipante: [],

                ParticipanteCrud: {
                    dsEmail: '',
                    tpSexo: '',
                    nmParticipante: '',
                    nmApelido: '',
                    nrCpf: '',
                    nrRg: '',
                    nrCelular: '',
                    dtNascimento: '',
                    idDepartamento: '',
                    idFuncao: '',
                    nmUf: '',
                },

                filter_tpSexo: null,
                filter_departamento: null,
                filter_funcao: null,
                cadastro_vinculado: null,
                cadastro_instituicao: null,

                isOpenModalVincularCadastro: false,

                lstRestricaoAlimentar: [],
                filtro_restricaoalimentar: false,


                filtro_pessoaDeficiencia: false,
                filtro_idTipoDeficiencia: { cdDeficiencia: 0 },
                lstPessoaDeficiencia: [],
                fl_descricaoDeficiencia: false,
                txtPesquisaInstituicao: '',
                showErrorMessage: false,
            };
        },
        methods: {
            zera_modal() {
                this.ParticipanteCrud = {
                    dsEmail: '',
                    tpSexo: '',
                    nmParticipante: '',
                    nmApelido: '',
                    nrCpf: '',
                    nrRg: '',
                    nrCelular: '',
                    dtNascimento: '',
                    idDepartamento: '',
                    idFuncao: '',
                    nmUf: '',
                };

                this.InscricaoCrud = {
                    inscricao: {
                        dsEmail: '',
                        nmNomeResponsavel: '',
                        dsEmailResponsavel: '',
                        nrTelefoneResponsavel: '',
                        nrCelularResponsavel: '',
                        idDepartamentoResponsavel: '',
                        idFuncaoResponsavel: '',
                        nmNomeFinanceiro: '',
                        dsEmailFinanceiro: '',
                        nrTelefoneFinanceiro: '',
                        nrCelularFinanceiro: '',
                        idDepartamentoFinanceiro: '',
                        idFuncaoFinanceiro: '',
                        idConvenio: '',
                        flSalaoPrincipal: false,
                        tpSexo: null,
                    },
                    instituicao: {
                        nmNome: '',
                        nrTelefone: '',
                        nrCelular: '',
                        dsCep: '',
                        dsEndereco: '',
                        nrNumero: '',
                        dsComplemento: '',
                        nmBairro: '',
                        nmCidade: '',
                        nmUf: '',
                        idAmbito: '',
                        nrCpfCnpj: '',
                    },
                };

                this.filter_tpSexo = null;
                this.filter_departamento = null;
                this.filter_funcao = null;

                this.cadastro_vinculado = null;
                this.cadastro_instituicao = null;
                this.lstRestricaoAlimentar = [];
                this.filtro_restricaoalimentar = false;
                this.filtro_pessoaDeficiencia = false;
                this.filtro_idTipoDeficiencia = { cdDeficiencia: 0 };
                this.lstPessoaDeficiencia = [];
                this.fl_descricaoDeficiencia = false;
                this.txtPesquisaInstituicao = '';
                this.showErrorMessage = false;
            },
            GetModalResponsavelInscricao() {
                let $this = this;
              
                //$this.zera_modal();

                $this.getParticipante();
                $this.getParticipantes();

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Inscricao/GetModalInscricao?idInscricao=" + $this.idInscricao,
                    {
                        headers: $this.$api.getTokenEventos(),
                        params: "",
                        notLoading: false
                    }
                ).then((response) => {
                    $this.InscricaoCrud = response.data.data;

                    setTimeout(() => {
                        $this.filter_tpSexo = $this.sexos.find((g) => {
                            return g.value == $this.ParticipanteCrud.tpSexo;

                        });
                        $this.filter_departamento = $this.departamentos.find((g) => {
                            return g.idDepartamento == $this.InscricaoCrud.inscricao.idDepartamentoResponsavel;
                        });

                        $this.filter_funcao = $this.funcoes.find((g) => {
                            return g.idFuncao == $this.InscricaoCrud.inscricao.idFuncaoResponsavel;
                        });
                    }, 200);


                });
            },

            getParticipante() {
                let $this = this;

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Participante/GetById?idParticipante=" + $this.idParticipante,
                    {
                        headers: $this.$api.getTokenEventos(),
                        params: "",
                        notLoading: false
                    }
                ).then((response) => {
                    $this.ParticipanteCrud = response.data.data;
                    $this.ParticipanteCrud.dtNascimento = moment($this.ParticipanteCrud.dtNascimento).format("DD/MM/YYYY");

                    $this.filtro_pessoaDeficiencia = $this.ParticipanteCrud.idTipoDeficiencia > 0 ? true : false;

                    $this.getVinculos();
                    $this.getInstituicao();
                    $this.getRestricaoAlimentar();
                    $this.getDeficiencia();
                });
            },

            getNmDepartamento(idDepartamentoResponsavel) {
                if (idDepartamentoResponsavel > 0 && this.filter_departamento) {
                    return this.filter_departamento.nmDepartamento
                }
                return ""
            },

            getNmFuncao(idFuncaoResponsavel) {
                if (idFuncaoResponsavel > 0 && this.filter_funcao) {
                    return this.filter_funcao.nmFuncao
                }
                return ""
            },

            getParticipantes() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Participante/Get', {
                    headers: $this.$api.getTokenEventos(),
                    params: {
                        idInscricao: $this.idInscricao,
                        flCancelado: "Não",
                    },
                }).then(response => {
                    $this.lstParticipante = response.data.data;
                });
            },

            getDepartamento() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Departamento/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.departamentos = response.data.data.rows;
                });
            },
            getFuncao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Funcao/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.funcoes = response.data.data.rows;
                });
            },
            getRestricaoAlimentar() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetRestricoesAlimentares?idParticipante=' + $this.idParticipante, {
                    headers: $this.$api.getTokenEventos(),
                    params: ''
                }).then(response => {
                    $this.lstRestricaoAlimentar = response.data.data;

                    $this.filtro_restricaoalimentar = $this.lstRestricaoAlimentar.some(x => x.checked_box === true);
                });
            },
            getDeficiencia() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetPessoaDeficiencia', {
                    headers: $this.$api.getTokenEventos(),
                    params: ''
                }).then(response => {
                    $this.lstPessoaDeficiencia = response.data.data;

                    $this.$nextTick(() => {

                        $this.filtro_idTipoDeficiencia = $this.lstPessoaDeficiencia.find((g) => {
                            return g.idTipoDeficiencia == $this.ParticipanteCrud.idTipoDeficiencia;
                        });
                    })
                });
            },
            getVinculos() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetDropVindulados', {
                    headers: $this.$api.getTokenEventos(),
                    params: {
                        p_idVinculo: $this.ParticipanteCrud.idPessoa,
                        p_tpPessoa: "F",
                        p_nrCpfCnpj: $this.ParticipanteCrud.nrCpfCnpj,
                        p_dsEmail: $this.ParticipanteCrud.dsEmail,
                    },
                }).then(response => {
                    $this.vinculos = response.data.data.rows;
                    $this.$nextTick(() => {
                        $this.cadastro_vinculado = $this.vinculos.find((g) => {
                            return g.value == $this.ParticipanteCrud.idPessoa;
                        });
                    })
                });
            },
            getInstituicao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Instituicao/GetInstituicaoById?id=' + $this.ParticipanteCrud.idInstituicao, {
                    headers: $this.$api.getTokenComercial(),
                    params: ""
                }).then(response => {
                    let instituicao = response.data.data;
                    $this.instituicoes = [
                        {
                            text: "#" + instituicao.cdInstituicao + ' - ' + instituicao.nrCnpj + ' - ' + instituicao.nmRazaoSocial,
                            value: instituicao.idInstituicao
                        }
                    ];

                    $this.$nextTick(() => {
                        $this.cadastro_instituicao = $this.instituicoes.find((g) => {
                            return g.value == $this.ParticipanteCrud.idInstituicao;
                        });

                    })
                });
            },
            pesquisaInstituicao() {
                let $this = this;
                if ($this.txtPesquisaInstituicao.length > 0) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Instituicao/GetInstituicoes?take=50&filter=' + $this.txtPesquisaInstituicao, {
                        headers: $this.$api.getTokenComercial(),
                        params: ""
                    }).then(response => {
                        $this.instituicoes = [];
                        for (let i = 0; i < response.data.data.rows.length; i++) {
                            var item = response.data.data.rows[i];
                            $this.instituicoes.push(
                                {
                                    text: "#" + item.cdInstituicao + ' - ' + item.nrCnpj + ' - ' + item.nmRazaoSocial,
                                    value: item.idInstituicao
                                }
                            );
                        }
                    });
                } else {
                    $this.$toast.show("alert", "Favor informar ao menos 3 caracteres", true);
                }

            },
            respostaVinculo(/*idVinculo*/) {
                this.getVinculos();
            },

            submit_Form_DadosPassaporte() {
                let $this = this;

                if ($this.InscricaoCrud.instituicao.tpInstituicao == 'J') {
                    if ($this.ParticipanteCrud.idInstituicao <= 0 || $this.ParticipanteCrud.idInstituicao == null) {
                        $this.$toast.show('alert', 'Sem instituição vinculada.', true);
                        return;
                    }
                }                

                $this.$refs.Form_DadosPassaporte.validate()
                    .then(isValid => {
                        var objCadastro = Object.assign({}, $this.ParticipanteCrud, {
                            idInscricao: $this.idInscricao,
                            idPessoa: $this.cadastro_vinculado.value,
                            idInstituicao: ($this.cadastro_instituicao != null ? $this.cadastro_instituicao.value : 0),
                            idDepartamento: $this.filter_departamento.idDepartamento,
                            idFuncao: $this.filter_funcao.idFuncao,
                            dtNascimento: moment($this.ParticipanteCrud.dtNascimento, "DD/MM/YYYY").format("YYYY-MM-DD") + "T00:00:00",
                            restricoesAlimentares: $this.lstRestricaoAlimentar
                        });

                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/PostParticipanteInscricao', objCadastro, { headers: $this.$api.getTokenEventos() })
                                .then(function (response) {
                                    $this.fecha_modal();
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        console.log('Error during validation: ', error); // Log the error
                        var msg = 'Por favor, preencha todos os campos obrigatórios.';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },

            fecha_modal() {
                this.$emit('reloadAll');
            },


        },
        mounted() {
            this.getDepartamento();
            this.getFuncao();
        },
        watch: {
            show(n, o) {
                if (n) {
                    this.GetModalResponsavelInscricao();
                }
            },
            idParticipante(n, o) { },
            filtro_idTipoDeficiencia(n, o) {
                if (n != undefined) {
                    if (n.cdDeficiencia == 4) {
                        this.fl_descricaoDeficiencia = true;
                    } else {
                        this.fl_descricaoDeficiencia = false;
                    }
                } else {
                    this.fl_descricaoDeficiencia = false;
                }

                if (n) {
                    this.ParticipanteCrud.idTipoDeficiencia = n.idTipoDeficiencia;
                }
            },
            filter_tpSexo(n) {
                if (n) {
                    this.ParticipanteCrud.tpSexo = n.value;
                }
            },
            filter_departamento(n) {
                if (n) {
                    this.ParticipanteCrud.idDepartamento = n.idDepartamento;
                }
            },
            filter_funcao(n) {
                if (n) {
                    this.ParticipanteCrud.idFuncao = n.idFuncao;
                }
            },
            filtro_restricaoalimentar(n) {
                if (!n) {
                    for (let i = 0; i < this.lstRestricaoAlimentar.length; i++) {
                        if (this.lstRestricaoAlimentar[i]) {
                            this.lstRestricaoAlimentar[i].checked_box = false;
                        }
                    }
                }
            },

            filtro_pessoaDeficiencia(n) {
                if (!n) {
                    this.ParticipanteCrud.idTipoDeficiencia = null;
                    this.ParticipanteCrud.dsTipoDeficiencia = null;
                    this.filtro_idTipoDeficiencia = { cdDeficiencia: 0 };
                }
            },

            cadastro_instituicao(n, o) {
                this.ParticipanteCrud.idInstituicao = n.value;
            },

        },
    };

</script>

<style scoped lang="scss">
    .coluna-dados p{
        margin-bottom: 5px;
    }
    .spinner-grow-static {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: .75;
    }
</style>